import { useSnackbar } from "notistack";
import type { FC } from "react";
import { getCalculationPdf } from "../../../api/api";
import DownloadFileButton from "../../components/downloadFileButton/DownloadFileButton";
import type { CalculationType } from "../calculationTypes";

interface Props {
  readonly calculationId: string;
  readonly calculationType: CalculationType;
  readonly version: number;
  readonly filename: string;
}

const DownloadCalculationPdfButton: FC<Props> = ({ calculationId, calculationType, version, filename }) => {
  const { enqueueSnackbar } = useSnackbar();
  const options = [
    { name: "Bez cen opcji", apiDefinition: () => getCalculationPdf(calculationId, version, false) },
    {
      name: "Z cenami opcji",
      apiDefinition: () => getCalculationPdf(calculationId, version, true),
      disabled: calculationType === "PACKAGE",
    },
  ];
  return (
    <DownloadFileButton
      buttonText="Pobierz kalkulację"
      options={options}
      onError={() => enqueueSnackbar("Nie udało się pobrać pliku PDF z kalkulacją", { variant: "error" })}
      filename={filename}
    />
  );
};

export default DownloadCalculationPdfButton;
